export const LOGO_URL = 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg';
export const SOURCE_PATH = 'https://github.com/alitajs/ant-design-plus/edit/master';

export const DOCS_DEFAULT_CONFIG = {
  sourcePath: 'https://github.com/alitajs/ant-design-plus/edit/master/src'
};
